import React, { useState } from 'react';
import { Container, Row, Col, Image, Accordion } from 'react-bootstrap';
import ArrowRight from '../assets/StartFreeIcon.svg';

const FEATURES = [
  {
    title: 'Prompt to Viral Post',
    description:
      'Write your ideas with Cero personalized AI-assistant, and Cero will create SEO-optimized Viral LinkedIn post for you. Your Tone, your niche, your post.',
    video: '/Video-1-AI-post-Generation.mp4',
  },
  {
    title: 'Viral Idea generator',
    description:
      'Write your ideas with Cero personalized AI-assistant, and Cero will create SEO-optimized Viral LinkedIn post for you. Your Tone, your niche, your post.',
    video: '/Video-2-Idea-Generator.mp4',
  },
  {
    title: 'Image/Carousel templates',
    description:
      'Write your ideas with Cero personalized AI-assistant, and Cero will create SEO-optimized Viral LinkedIn post for you. Your Tone, your niche, your post.',
    video: '/Video-3-Image-Carousel.mp4',
  },
  {
    title: 'AI Comments Engagement',
    description:
      'Write your ideas with Cero personalized AI-assistant, and Cero will create SEO-optimized Viral LinkedIn post for you. Your Tone, your niche, your post.',
    video: '/Video-4-Comment-Generator.mp4',
  },
];

const FeatureVideo: React.FC<{ className?: string; src: string; title: string }> = ({
  className,
  src,
  title,
}) => (
  <div className={`brand-wings__feature-video ${className ?? ''}`} style={featureVideoStyles.container}>
    <video
      src={src}
      controls
      playsInline
      preload="metadata"
      title={title}
      style={featureVideoStyles.video}
    />
  </div>
);

const featureVideoStyles: Record<string, React.CSSProperties> = {
  container: {
    background: 'rgba(165, 165, 165, 0.12)',
    borderRadius: 12,
    width: '100%',
    minHeight: 200,
    overflow: 'hidden',
    position: 'relative',
  },
  video: {
    width: '100%',
    height: '100%',
    minHeight: 200,
    display: 'block',
    borderRadius: 12,
    objectFit: 'cover',
    background: '#0B0B0B',
  },
};

export const BrandWings: React.FC = () => {
  const [activeKey, setActiveKey] = useState('0');

  return (
    <Container
      id="features"
      fluid
      className="justify-content-center brand-wings"
      style={{ paddingTop: 40 }}
    >
      <style>{`
        .brand-wings__features {
          width: calc(80% - 100px);
          margin: 40px auto 0;
          padding-bottom: 50px;
        }

        .brand-wings__accordion-panel {
          background: transparent;
          border-radius: 15px;
          overflow: hidden;
          border: 1px solid transparent;
          background-image:
            linear-gradient(transparent, transparent),
            linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%);
          background-origin: border-box;
          background-clip: padding-box, border-box;
          box-shadow: inset 0px 0px 8px 0px #FFFFFF0A;
          padding: 12px;
          height: 100%;
        }

        .brand-wings__mobile-video {
          margin-top: 24px;
        }

        .brand-wings__start-free-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 40px;
          height: 56px;
          padding-left: 28px;
          padding-right: 16px;

          border-radius: 16px;

          border: 1.5px solid rgba(255, 128, 0, 0.4);
          background: rgba(255, 128, 0, 0.2);

          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);

          box-shadow: inset 0 0 24px rgba(255, 128, 0, 0.24);

          color: #fff;
          font-family: Inter, sans-serif;
          font-size: 20px;
          font-weight: 500;

          white-space: nowrap;
          cursor: pointer;
          box-sizing: border-box;
        }

        .brand-wings__start-free-btn__icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        .brand-wings__start-free-btn:hover {
          background: rgba(255, 128, 0, 0.24);
          color: #ffffff;
        }

        .brand-wings__start-free-btn__icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        @media (max-width: 991.98px) {
          .brand-wings {
            padding-left: 16px !important;
            padding-right: 16px !important;
            overflow-x: clip;
          }

          .brand-wings > .row {
            --bs-gutter-x: 0;
            margin-left: 0;
            margin-right: 0;
          }

          .brand-wings > .row > [class*='col-'] {
            padding-left: 0;
            padding-right: 0;
          }

          .brand-wings__features {
            width: 100%;
            padding-left: 0;
            padding-right: 0;
            margin-top: 32px;
          }

          .brand-wings__features > .row {
            --bs-gutter-x: 0;
            margin-left: 0;
            margin-right: 0;
          }

          .brand-wings__features > .row > [class*='col-'] {
            padding-left: 0;
            padding-right: 0;
          }

          .brand-wings__accordion-panel {
            background: transparent;
            border: none;
            box-shadow: none;
            padding: 0;
            background-image: none;
          }

          .brand-wings__accordion .accordion-item {
            background: transparent;
            color: #fff;
            border: 1px solid rgba(255, 255, 255, 0.18);
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 12px;
            position: relative;
            overflow: hidden;
          }

          .brand-wings__accordion .accordion-button {
            background: transparent !important;
            color: #fff !important;
            box-shadow: none !important;
            padding: 0;
          }

          .brand-wings__accordion .accordion-button:not(.collapsed) {
            background: transparent !important;
            color: #fff !important;
          }

          .brand-wings__accordion .accordion-body {
            background: transparent;
            padding: 0;
          }

          .brand-wings__accordion .accordion-item::before {
            content: '';
            position: absolute;
            inset: 0;
            background: rgba(255, 255, 255, 0.04);
            border-radius: 12px;
            pointer-events: none;
          }

          .brand-wings__accordion .accordion-item::after {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 12px;
            box-shadow: inset 0px 0px 8px 0px rgba(255, 255, 255, 0.04);
            pointer-events: none;
          }

          .brand-wings__accordion .accordion-button {
            font-family: Inter, sans-serif;
            font-weight: 500;
            font-size: 16px;
            line-height: normal;
            color: rgba(255, 255, 255, 0.96) !important;
          }

          .brand-wings__accordion .accordion-body {
            padding-top: 12px;
          }

          .brand-wings__feature-title {
            font-size: 14px !important;
            line-height: normal !important;
          }

          .brand-wings__feature-description {
            font-size: 14px !important;
            line-height: normal !important;
            color: rgba(255, 255, 255, 0.42) !important;
          }

          .brand-wings__desktop-video-col {
            display: none !important;
          }

          .brand-wings__maintext {
            line-height: 1.4 !important;
          }
        }

        @media (min-width: 992px) {
          .brand-wings__mobile-video {
            display: none !important;
          }

          .brand-wings__desktop-video-col .brand-wings__feature-video {
            flex: 1;
            min-height: 280px;
          }
        }
      `}</style>

      <Row className="w-100 justify-content-center" style={{ marginBottom: 120 }}>
        <Col
          xs={12}
          md={10}
          lg={9}
          xl={8}
          className="d-flex flex-column align-items-center text-center"
        >
          <div
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 48,
              lineHeight: '100%',
              letterSpacing: '-2%',
              color: '#FFFFFF',
            }}
          >
            Give your Personal Brand wings
          </div>
          <div
            className="brand-wings__maintext"
            style={{
              marginTop: 20,
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: 20,
              lineHeight: '42px',
              color: '#FFFFFF6B',
              maxWidth: 1120,
            }}
          >
            Cero has all the features you need to create viral and goal-oriented LinkedIn content in
            seconds. Simpler and faster than ever before.
          </div>

          <button type="button" className="brand-wings__start-free-btn">
            Start Free
            <Image
              src={ArrowRight}
              alt=""
              aria-hidden
              className="brand-wings__start-free-btn__icon"
            />
          </button>
        </Col>
      </Row>

      <div className="brand-wings__features">
        <Row className="g-2 align-items-stretch">
          <Col xs={12} lg={5} className="px-2">
            <div className="brand-wings__accordion-panel">
              <Accordion
                activeKey={activeKey}
                defaultActiveKey="0"
                onSelect={(key) => {
                  if (key != null) setActiveKey(String(key));
                }}
                flush
                className="brand-wings__accordion"
                style={
                  {
                    background: 'transparent',
                    '--bs-accordion-bg': 'transparent',
                    '--bs-accordion-btn-bg': 'transparent',
                    '--bs-accordion-color': '#FFFFFF',
                    '--bs-accordion-active-bg': 'transparent',
                    '--bs-accordion-active-color': '#FFFFFF',
                    '--bs-accordion-border-color': 'rgba(255,255,255,0.1)',
                    '--bs-accordion-btn-focus-box-shadow': 'none',
                    '--bs-accordion-btn-color': '#FFFFFF',
                    '--bs-accordion-btn-icon':
                      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23FFFFFF' fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")",
                    '--bs-accordion-btn-active-icon':
                      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='%23FF8000' fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\")",
                  } as React.CSSProperties
                }
              >
                {FEATURES.map((feature, index) => (
                  <Accordion.Item
                    key={index}
                    eventKey={String(index)}
                    style={{ background: 'transparent', color: '#fff' }}
                  >
                    <Accordion.Header
                      style={{ background: 'transparent', color: '#fff', boxShadow: 'none' }}
                    >
                      <span
                        className="brand-wings__feature-title"
                        style={{
                          fontFamily: 'Inter, sans-serif',
                          fontWeight: 400,
                          fontSize: 19,
                          lineHeight: '32px',
                          color: '#FFFFFF',
                        }}
                      >
                        {feature.title}
                      </span>
                    </Accordion.Header>
                    <Accordion.Body style={{ background: 'transparent' }}>
                      <div
                        className="brand-wings__feature-description"
                        style={{
                          fontFamily: 'Inter, sans-serif',
                          fontWeight: 400,
                          fontSize: 16,
                          lineHeight: '24px',
                          color: '#FFFFFF6B',
                          textAlign: 'left',
                        }}
                      >
                        {feature.description}
                      </div>
                      <FeatureVideo
                        className="brand-wings__mobile-video"
                        src={feature.video}
                        title={feature.title}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </Col>
          <Col xs={12} lg={7} className="px-2 d-flex brand-wings__desktop-video-col">
            <FeatureVideo
              src={FEATURES[Number(activeKey)].video}
              title={FEATURES[Number(activeKey)].title}
            />
          </Col>
        </Row>
      </div>
    </Container>
  );
};
